const riskEntered = (risk) => {
    return risk
        && (risk.none === true
            || risk.medical > 0
            || risk.surgical > 0
            || risk.activity > 0
            || risk.social > 0
        )
}

// Which session of the direct billing the visit's appointment is (like Insurance > Appts), not the total booked count.
// "-" when the CPT's approved sessions were used up before this appointment; falls back to the total when the
// appointment isn't one of the direct billing's used appointments (e.g. cancelled / no-show).
const directBillingSessionLabel = (insuranceApproval, item) => {
    const usedAppointmentIds = insuranceApproval?.directBilling?.usedAppointmentIds || [];
    const sessionNo = usedAppointmentIds.indexOf(insuranceApproval?.appointmentId) + 1;
    if (sessionNo === 0) {
        return `${item.noOfUsedSessions}/${item.noOfApprovedSessions}`;
    }
    return `${sessionNo <= item.noOfApprovedSessions ? sessionNo : '-'}/${item.noOfApprovedSessions}`;
}

export default {riskEntered, directBillingSessionLabel}